/*!

=========================================================
* Paper Kit React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates strings
import classnames from "classnames";
// reactstrap components
import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
} from "reactstrap";

import { useRecoilValue } from "recoil";
import { websiteDataState } from "helpers/recoil";

import { scroller } from 'react-scroll';

function IndexNavbar() {
  const websiteData = useRecoilValue(websiteDataState)

  // const [navbarColor, setNavbarColor] = React.useState("");
  const [navbarCollapse, setNavbarCollapse] = React.useState(false);

  const toggleNavbarCollapse = () => {
    setNavbarCollapse(!navbarCollapse);
    document.documentElement.classList.toggle("nav-open");
  };

  const scrollTo = (location) => {
    scroller.scrollTo(location, {
      smooth: true,
      offset: -70,
      duration: 500,
    })
  }

  return (
    <Navbar className={classnames("fixed-top", "")} expand="lg" style={{ 
      backgroundColor: "rgba(255, 255, 255, 0.98)", 
      boxShadow: "0 2px 20px rgba(0, 0, 0, 0.1)",
      backdropFilter: "blur(10px)",
      transition: "all 0.3s ease",
      padding: "15px 0"
    }}>
      <Container style={{ display: "flex", alignItems: "center" }}>
        <div className="navbar-translate" style={{ display: "flex", alignItems: "center", flex: "0 0 auto" }}>
          <NavbarBrand
            data-placement="bottom"
            title="Kinesitherapie Notebaert - Standaert"
            style={{ 
              margin: 0, 
              padding: 0,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center"
            }}
          >
            <span style={{ 
              color: "#2d3748", 
              fontWeight: "700", 
              fontSize: "16px",
              lineHeight: "1.3",
              display: "block",
              letterSpacing: "-0.3px"
            }}>Notebaert <span style={{ color: "#69be50" }}>|</span> Standaert</span>
            <span style={{ 
              background: "linear-gradient(135deg, #69be50 0%, #5aa542 100%)", 
              color: "#FFFFFF", 
              padding: "3px 8px", 
              fontSize: "10px",
              fontWeight: "600",
              borderRadius: "3px",
              display: "inline-block",
              boxShadow: "0 2px 8px rgba(105, 190, 80, 0.3)",
              marginTop: "4px",
              letterSpacing: "0.3px"
            }}>Groepspraktijk kinesitherapie</span>
          </NavbarBrand>
          <button aria-expanded={navbarCollapse} className={classnames("navbar-toggler navbar-toggler", { toggled: navbarCollapse, })} onClick={toggleNavbarCollapse} >
            <span className="navbar-toggler-bar bar1" />
            <span className="navbar-toggler-bar bar2" />
            <span className="navbar-toggler-bar bar3" />
          </button>
        </div>
        <Collapse className="justify-content-end" navbar isOpen={navbarCollapse} style={{ alignItems: "center" }}>
          <Nav navbar style={{ alignItems: "center" }}>
            <NavItem>
              <NavLink href="#" onClick={() => scrollTo('wiezijnwe')} style={{ 
                fontWeight: "600", 
                color: "#2d3748",
                fontSize: "14px",
                transition: "all 0.3s ease",
                padding: "10px 14px",
                borderRadius: "6px",
                textTransform: "none",
                letterSpacing: "0.2px"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = "#69be50";
                e.currentTarget.style.backgroundColor = "rgba(105, 190, 80, 0.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = "#2d3748";
                e.currentTarget.style.backgroundColor = "transparent";
              }}> {websiteData?.snippetsDictionary?.['section-header-wiezijnwe']?.text || ""} </NavLink>
            </NavItem>

            <NavItem>
              <NavLink href="#" onClick={() => scrollTo('specialisme')} style={{ 
                fontWeight: "700", 
                color: "#2d3748",
                fontSize: "15px",
                transition: "all 0.3s ease",
                padding: "10px 16px",
                borderRadius: "6px",
                textTransform: "none"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = "#69be50";
                e.currentTarget.style.backgroundColor = "rgba(105, 190, 80, 0.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = "#2d3748";
                e.currentTarget.style.backgroundColor = "transparent";
              }}> {websiteData?.snippetsDictionary?.['section-header-specialisaties']?.text || ""} </NavLink>
            </NavItem>

            <NavItem>
              <NavLink href="#" onClick={() => scrollTo('team')} style={{ 
                fontWeight: "700", 
                color: "#2d3748",
                fontSize: "15px",
                transition: "all 0.3s ease",
                padding: "10px 16px",
                borderRadius: "6px",
                textTransform: "none"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = "#69be50";
                e.currentTarget.style.backgroundColor = "rgba(105, 190, 80, 0.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = "#2d3748";
                e.currentTarget.style.backgroundColor = "transparent";
              }}>  {websiteData?.snippetsDictionary?.['section-header-team']?.text || ""}  </NavLink>
            </NavItem>

            <NavItem>
              <NavLink href="#" onClick={() => scrollTo('tarieven')} style={{ 
                fontWeight: "700", 
                color: "#2d3748",
                fontSize: "15px",
                transition: "all 0.3s ease",
                padding: "10px 16px",
                borderRadius: "6px",
                textTransform: "none"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = "#69be50";
                e.currentTarget.style.backgroundColor = "rgba(105, 190, 80, 0.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = "#2d3748";
                e.currentTarget.style.backgroundColor = "transparent";
              }}>  {websiteData?.snippetsDictionary?.['section-header-tarieven']?.text || ""}  </NavLink>
            </NavItem>

            <NavItem>
              <NavLink href="#" onClick={() => scrollTo('gallery')} style={{ 
                fontWeight: "700", 
                color: "#2d3748",
                fontSize: "15px",
                transition: "all 0.3s ease",
                padding: "10px 16px",
                borderRadius: "6px",
                textTransform: "none"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = "#69be50";
                e.currentTarget.style.backgroundColor = "rgba(105, 190, 80, 0.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = "#2d3748";
                e.currentTarget.style.backgroundColor = "transparent";
              }}>  {websiteData?.snippetsDictionary?.['section-header-gallery']?.text || ""}  </NavLink>
            </NavItem>

            <NavItem>
              <NavLink href="#" onClick={() => scrollTo('contact')} style={{ 
                fontWeight: "700", 
                color: "#2d3748",
                fontSize: "15px",
                transition: "all 0.3s ease",
                padding: "10px 16px",
                borderRadius: "6px",
                textTransform: "none"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = "#69be50";
                e.currentTarget.style.backgroundColor = "rgba(105, 190, 80, 0.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = "#2d3748";
                e.currentTarget.style.backgroundColor = "transparent";
              }}>  {websiteData?.snippetsDictionary?.['section-header-contact']?.text || ""}  </NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
}

export default IndexNavbar;
